import React, { useState, useEffect } from "react";

export interface Brand {
  id: number;
  name: string;
  logo_url: string;
}

interface Props {
  brands: Brand[];
  onBrandClick: (brand: Brand) => void;
}

/**
 * Brands
 * Displays a selectable list of brands and highlights the active selection.
 */
const Brands = ({ brands, onBrandClick }: Props) => {
  const [selectedId, setSelectedId] = useState<number | null>(null);

  useEffect(() => {
    if (brands.length > 0 && selectedId === null) {
      setSelectedId(brands[0].id);
      onBrandClick(brands[0]);
    }
  }, [brands, selectedId, onBrandClick]);

  const handleClick = (brand: Brand) => {
    setSelectedId(brand.id);
    onBrandClick(brand);
  };

  return (
    <div className="text-center my-12">
      <h2 className="text-3xl font-bold text-[#5c2f2f] mb-8">Brands</h2>

      <div className="flex flex-wrap justify-center gap-8">
        {brands.map((brand) => {
          const active = selectedId === brand.id;

          return (
            <button
              key={brand.id}
              onClick={() => handleClick(brand)}
              className={`text-xl uppercase font-semibold transition duration-300 bg-transparent ${
                active
                  ? "text-[#3f1f1f]"
                  : "text-[#7a4343] hover:text-[#5c2f2f]"
              }`}
            >
              <span
                className={
                  active
                    ? "[text-shadow:0_0_14px_rgba(92,47,47,0.55)]"
                    : "hover:[text-shadow:0_0_10px_rgba(92,47,47,0.30)]"
                }
              >
                {brand.name}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Brands;
